// The AI Workspace's built-in widgets and matter tabs, which the space designer places beside pages.
export default {
  spaceBuiltins: {
    noPlaybooks: "Add playbooks on the Capabilities tab first.",
    playbookDefault: "Playbook's tabs",
    playbookNone: "This playbook adds no tabs.",
    moveUp: "Move up",
    moveDown: "Move down",
    remove: "Remove",
    widget: {
      "ask": { name: "Ask", hint: "The composer with four starting questions; a question opens a chat, research goes to the evidence researcher." },
      "start-work": { name: "Start work", hint: "The workspace's main processes, each with what it is for, what it produces, the typical time and an example." },
      "my-work": { name: "Your work", hint: "The member's open files with the current stage, the next step and the due date." },
      "needs-decision": { name: "Needs your decision", hint: "This workspace's proposals waiting for review, with a link to the Inbox." },
      "economy-strip": { name: "Economy at a glance", hint: "Six headline indicators with freshness, linking to Evidence." },
      "launchers": { name: "Launchers", hint: "Start a new-economy study, an economic study or a policy; research-grade prompts." },
      "economic-pulse": { name: "Economic pulse", hint: "Headline UAE indicators with source role, freshness, sparkline and the international comparison." },
      "national-targets": { name: "National targets", hint: "Latest value against each national target, required against recent pace, with the basis." },
      "release-calendar": { name: "Releases and revisions", hint: "Expected releases this fortnight and revisions that touch open matters." },
      "portfolio-board": { name: "Portfolio board", hint: "The workspace's processes as lanes by stage, with deadline rings and what awaits the user." },
      "evidence-health": { name: "Evidence health", hint: "Each statistical source's mode, last refresh and whether it is stale or blocked." },
      "horizon-radar": { name: "Horizon radar", hint: "New-economy signals from newly ingested international publications, by theme." },
    },
    tab: {
      brief: "Brief",
      evidence: "Evidence",
      foresight: "Foresight",
      options: "Options",
      consultation: "Consultation",
      draft: "Draft",
      delivery: "Delivery",
      assurance: "Assurance",
      outputs: "Outputs",
      links: "Links",
    },
  },
};
